import { dispatchTwiceGetImpactVenueCo2 } from '@/domain/impact-calculate-venue/actions/utils/dispatch-twice-get-impact-venue-co2.ts';
import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors.ts';
import { VenueDate } from '@/domain/project-venue-dates/entities/project-venue-dates.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

export const editVenueDates = createAppAsyncThunk(
  'projectVenueDates/editVenueDates',
  async (
    param: { venueDate: VenueDate },
    {
      extra: { projectVenueDatesGateway, snackbarGateway },
      getState,
      dispatch,
    },
  ): Promise<VenueDate> => {
    try {
      const currentProject = selectCurrentProjectVenue(getState());
      const venueDate = await projectVenueDatesGateway.edit(param.venueDate);

      // Wait for calcul
      if (currentProject) {
        setTimeout(async () => {
          dispatchTwiceGetImpactVenueCo2(dispatch, currentProject.id);
        }, 2000);
      }

      return venueDate;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetVenueDates.Message.error'));
}
